import type { TextPropView } from '@consta/uikit/Text'
import type { ReactNode } from 'react'

import { For } from '../../../../../components'
import { useActionContext } from '../../../context'
import { SettingContainer } from './SettingContainer'
import css from './SettingsBlock.css'

type SettingObjectsProps<T> = {
  view?: TextPropView
  children: (item: T) => ReactNode
}

export const SettingObjects = <T,>({ children, view }: SettingObjectsProps<T>) => {
  const { objects } = useActionContext<T>()

  const label = objects.length > 1 ? 'Объекты' : 'Объект'

  return (
    <SettingContainer className={css.objects} label={label} view={view}>
      <div className={css.list}>
        <For each={objects}>{children}</For>
      </div>
    </SettingContainer>
  )
}
